/*
 * @Author: caiqin.xie
 * @since: 2023-08-24 16:13:13
 * @lastTime: 2023-11-10 17:12:22
 * @LastEditors: caiqin.xie
 * @message: 配件
 * @url: www.picoxr.com/cn/accessory
 */
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import Banner from "./components/Banner";
import AccessoryList from "./components/AccessoryList";
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST, ACCESSORYPOS, ACCESSORYTYPE } from '@/common/const'
import styles from "./index.module.scss";

interface IList {
  id: string; // 配件id
  name: string; // 配件名称
  cover: string; // 封面图
  coverAlt: string; // 封面图alt
  briefIntroduction: string; // 简介
  [key: string]: any;
}

const Accessory = (props: any) => {
  const {ctry, words, data} = props.data

  const banner = data?.banners[0] || null // banner
  const accessoryList: IList[] = data?.accessoryProductVoList || [] // 配件列表

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/accessory`} />
      ))
    )
  }

  return (
    <div>
      <Helmet>
        <title>{words?.spare_part_seo_titile}</title>
        <meta name="description" content={words?.spare_part_seo_description} />
        <meta name="keywords" content={words?.spare_part_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/accessory`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['spare-wrap']}>
        <Banner ctry={ctry} words={words} banner={banner} />
        <div className={styles['content-wrap']}>
          <AccessoryList ctry={ctry} words={words} accessoryList={accessoryList} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit(ctry: string) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/accessory/selectList`, {
      accessoryId: ACCESSORYTYPE,
      stationCode: ctry,
      bannerPositionId: ACCESSORYPOS
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

Accessory.getInitialProps = (ctry: string) => {
  return getInit(ctry)
};
export default Accessory;
